import { KnaufColor } from './knauf-color';
import { Point } from './point';
export class Layer {
    color: KnaufColor = null;
    selected: boolean = false;
    name: string = null;
    points: Point[];
    cuts: Point[][] = [];
    opacity: number = 100;
}
